module.exports = __webpack_public_path__ + "static/img/12.acfe986.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/12/zh/12.png
// module id = 6tSb
// module chunks = 0